import { useContext, useMemo } from "react";
import { ProjectContext, TProjectContext } from "context/ProjectProvider";
import { QUERY_ENUM_VALUES } from "services/graphQL/queries";
import { useParams } from "react-router";
import { useCIQQuery } from "./ciq-gql-hooks";

export type EnumOptionsMap = Record<string, { id: string; value: string }[]>;

export const useEnumValues = (featureTypeId: number, skip = false) => {
  const { projectId } = useParams<{ projectId: string }>();
  const { gqlClientForProject }: TProjectContext = useContext(ProjectContext);

  const { data: enumValuesResponse } = useCIQQuery(QUERY_ENUM_VALUES, {
    client: gqlClientForProject,
    variables: { projectId, featureTypeId },
    skip: skip || !gqlClientForProject || !featureTypeId
  });

  const enumOptionsMap: EnumOptionsMap = useMemo(() => {
    const values = enumValuesResponse?.custom_field_enum_values;
    if (!values) return {};

    return values.reduce(
      (
        acc: EnumOptionsMap,
        item: { id: string; custom_field_key: string; value: string }
      ) => {
        const key = item.custom_field_key;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push({ id: item.id, value: item.value });
        return acc;
      },
      {}
    );
  }, [enumValuesResponse?.custom_field_enum_values]);

  return { enumOptionsMap };
};
